var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.38889 16.2219L8.18713 17.6663L0 8.99967L8.18714 0.333008L9.38889 1.77745L3.78889 7.99968H26V9.99968H3.78889L9.38889 16.2219Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLeftArrow);
export default __webpack_public_path__ + "static/media/big-left-arrow.4239ff16233b189ddb12b96ba04c0a83.svg";
export { ForwardRef as ReactComponent };